module.exports = __webpack_public_path__ + "static/media/Penduka.b49e9dec.webp";